import viewDemandeCandidature from "./ViewDemandeCandidature";
export default viewDemandeCandidature;
